import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/front/Home.vue'
import ArticleDetail from '../views/front/ArticleDetail.vue'
import Tags from '../views/front/Tags.vue'
import Projects from '../views/front/Projects.vue'
import Tools from '../views/front/Tools.vue'
import Login from '../views/front/Login.vue'

// 后台页面
import AdminDashboard from '../views/admin/Dashboard.vue'
import AdminArticles from '../views/admin/Articles.vue'
import AdminArticleEdit from '../views/admin/ArticleEdit.vue'
import AdminCategories from '../views/admin/Categories.vue'
import AdminTags from '../views/admin/Tags.vue'
import AdminUsers from '../views/admin/Users.vue'
import AdminViewRecords from '../views/admin/ViewRecords.vue'
import AdminProjects from '../views/admin/Projects.vue'
import AdminProjectEdit from '../views/admin/ProjectEdit.vue'

Vue.use(VueRouter)

const routes = [
  // 前端页面
  { path: '/', name: 'Home', component: Home },
  { path: '/article/:slug', name: 'ArticleDetail', component: ArticleDetail },
  { path: '/tags', name: 'Tags', component: Tags },
  { path: '/projects', name: 'Projects', component: Projects },
  { path: '/tools', name: 'Tools', component: Tools },
  { path: '/login', name: 'Login', component: Login },

  // 后台管理
  { path: '/admin', name: 'AdminDashboard', component: AdminDashboard, meta: { requiresAuth: true, isAdmin: true } },
  { path: '/admin/articles', name: 'AdminArticles', component: AdminArticles, meta: { requiresAuth: true, isAdmin: true } },
  { path: '/admin/articles/create', name: 'AdminArticleCreate', component: AdminArticleEdit, meta: { requiresAuth: true, isAdmin: true } },
  { path: '/admin/articles/edit/:id', name: 'AdminArticleEdit', component: AdminArticleEdit, meta: { requiresAuth: true, isAdmin: true } },
  { path: '/admin/categories', name: 'AdminCategories', component: AdminCategories, meta: { requiresAuth: true, isAdmin: true } },
  { path: '/admin/tags', name: 'AdminTags', component: AdminTags, meta: { requiresAuth: true, isAdmin: true } },
  { path: '/admin/users', name: 'AdminUsers', component: AdminUsers, meta: { requiresAuth: true, isAdmin: true } },
  { path: '/admin/view-records', name: 'AdminViewRecords', component: AdminViewRecords, meta: { requiresAuth: true, isAdmin: true } },
  { path: '/admin/projects', name: 'AdminProjects', component: AdminProjects, meta: { requiresAuth: true, isAdmin: true } },
  { path: '/admin/projects/create', name: 'AdminProjectCreate', component: AdminProjectEdit, meta: { requiresAuth: true, isAdmin: true } },
  { path: '/admin/projects/edit/:id', name: 'AdminProjectEdit', component: AdminProjectEdit, meta: { requiresAuth: true, isAdmin: true } },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    return { x: 0, y: 0 }
  }
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  const isAdmin = to.matched.some(record => record.meta.isAdmin)
  const token = localStorage.getItem('token')

  if (requiresAuth && !token) {
    next({ path: '/login', query: { redirect: to.fullPath } })
  } else if (requiresAuth && isAdmin) {
    // 检查是否是管理员（简化处理，实际应验证 token 内容）
    next()
  } else {
    next()
  }
})

export default router
